import { OpenAPI } from "simplydo/interfaces";

import { API, APIError } from ".";
import SearchParams from "../searchParams";

export const innointel = (api: API) => ({
  getSearches(
    params: OpenAPI.GET<"/innointel/searches">["parameters"]["query"],
    success: (data: OpenAPI.GET<"/innointel/searches">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    const queryParams = new SearchParams(params);
    api.authenticatedRequest(
      "GET",
      `/innointel/searches${queryParams.toSafeString()}  `,
      null,
      success,
      fail,
    );
  },
  getSearch(
    searchId: string,
    success: (
      data: OpenAPI.GET<"/innointel/searches/{search_id}">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/innointel/searches/${searchId}`,
      null,
      success,
      fail,
    );
  },
  getSearchDebug(
    searchId: string,
    success: (
      data: OpenAPI.GET<"/innointel/searches/{search_id}/debug">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/innointel/searches/${searchId}/debug`,
      null,
      success,
      fail,
    );
  },
  getSearchDebugCompany(
    searchId: string,
    companyId: string,
    success: (
      data: OpenAPI.GET<"/innointel/searches/{search_id}/debug/companies/{company_id}">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/innointel/searches/${searchId}/debug/companies/${companyId}`,
      null,
      success,
      fail,
    );
  },
  getSearchCompanies(
    searchId: string,
    params: OpenAPI.GET<"/innointel/searches/{search_id}/companies">["parameters"]["query"],
    success: (
      data: OpenAPI.GET<"/innointel/searches/{search_id}/companies">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    const queryParams = new SearchParams(params);
    api.authenticatedRequest(
      "GET",
      `/innointel/searches/${searchId}/companies${queryParams.toSafeString()}`,
      null,
      success,
      fail,
    );
  },
  excludeCompanies(
    searchId: string,
    data: OpenAPI.POST<"/innointel/searches/{search_id}/companies/exclude">["requestBody"],
    success: (
      data: OpenAPI.POST<"/innointel/searches/{search_id}/companies/exclude">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/innointel/searches/${searchId}/companies/exclude`,
      data,
      success,
      fail,
    );
  },
  includeCompanies(
    searchId: string,
    data: OpenAPI.POST<"/innointel/searches/{search_id}/companies/include">["requestBody"],
    success: (
      data: OpenAPI.POST<"/innointel/searches/{search_id}/companies/include">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/innointel/searches/${searchId}/companies/include`,
      data,
      success,
      fail,
    );
  },
  newSearch(
    data: OpenAPI.POST<"/innointel/searches/new">["requestBody"],
    success: (
      data: OpenAPI.POST<"/innointel/searches/new">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/innointel/searches/new`,
      data,
      success,
      fail,
    );
  },
  cancelSearch(
    searchId: string,
    success: (
      data: OpenAPI.POST<"/innointel/searches/{search_id}/cancel">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/innointel/searches/${searchId}/cancel`,
      null,
      success,
      fail,
    );
  },
  restartSearch(
    searchId: string,
    success: (
      data: OpenAPI.POST<"/innointel/searches/{search_id}/restart">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/innointel/searches/${searchId}/restart`,
      null,
      success,
      fail,
    );
  },
  processCompanies(
    searchId: string,
    data: OpenAPI.POST<"/innointel/searches/{search_id}/companies/process">["requestBody"],
    success: (
      data: OpenAPI.POST<"/innointel/searches/{search_id}/companies/process">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/innointel/searches/${searchId}/companies/process`,
      data,
      success,
      fail,
    );
  },
  deleteSearch(
    searchId: string,
    success: (
      data: OpenAPI.DELETE<"/innointel/searches/{search_id}">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "DELETE",
      `/innointel/searches/${searchId}`,
      null,
      success,
      fail,
    );
  },
  findCapturedCompany(
    url: string,
    success: (
      data: OpenAPI.GET<"/innointel/companies/capture">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/innointel/companies/capture?url=${encodeURIComponent(url)}`,
      null,
      success,
      fail,
    );
  },
  captureCompany(
    data: OpenAPI.POST<"/innointel/companies/capture">["requestBody"],
    success: (
      data: OpenAPI.POST<"/innointel/companies/capture">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      "/innointel/companies/capture",
      data,
      success,
      fail,
    );
  },
  getCompany(
    companyId: string,
    success: (
      data: OpenAPI.GET<"/innointel/companies/{company_id}">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/innointel/companies/${companyId}`,
      null,
      success,
      fail,
    );
  },
  getCompanyLocations(
    companyId: string,
    params: OpenAPI.GET<"/innointel/companies/{company_id}/locations">["parameters"]["query"],
    success: (
      data: OpenAPI.GET<"/innointel/companies/{company_id}/locations">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    const queryParams = new SearchParams(params);
    api.authenticatedRequest(
      "GET",
      `/innointel/companies/${companyId}/locations${queryParams.toSafeString()}`,
      null,
      success,
      fail,
    );
  },
  triggerCompanyEvent(
    companyId: string,
    data: OpenAPI.POST<"/innointel/companies/{company_id}/events">["requestBody"],
    success: (
      data: OpenAPI.POST<"/innointel/companies/{company_id}/events">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/innointel/companies/${companyId}/events`,
      data,
      success,
      fail,
    );
  },
  assignCreditsafeId(
    companyId: string,
    body: OpenAPI.POST<"/innointel/companies/{company_id}/creditsafe/assign">["requestBody"],
    success: (
      data: OpenAPI.POST<"/innointel/companies/{company_id}/creditsafe/assign">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/innointel/companies/${companyId}/creditsafe/assign`,
      body,
      success,
      fail,
    );
  },
  getCreditsafeReport(
    companyId: string,
    creditsafeIdToUse: string | undefined,
    success: (
      data: OpenAPI.GET<"/innointel/companies/{company_id}/creditsafe/report">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/innointel/companies/${companyId}/creditsafe/report${creditsafeIdToUse ? `?creditsafeId=${creditsafeIdToUse}` : ""}`,
      null,
      success,
      fail,
    );
  },
  getCreditsafeReportPdf(
    companyId: string,
    success: (
      data: OpenAPI.GET<"/innointel/companies/{company_id}/creditsafe/pdf">["response"],
    ) => void,
    fail: (error: any) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/innointel/companies/${companyId}/creditsafe/pdf`,
      null,
      success,
      fail,
    );
  },
  getLists(
    success: (data: OpenAPI.GET<"/innointel/lists">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest("GET", "/innointel/lists", null, success, fail);
  },
  createList(
    data: OpenAPI.PUT<"/innointel/lists">["requestBody"],
    success: (data: OpenAPI.PUT<"/innointel/lists">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest("PUT", "/innointel/lists", data, success, fail);
  },
  getList(
    listId: string,
    success: (
      data: OpenAPI.GET<"/innointel/lists/{list_id}">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/innointel/lists/${listId}`,
      null,
      success,
      fail,
    );
  },
  updateList(
    listId: string,
    data: OpenAPI.POST<"/innointel/lists/{list_id}">["requestBody"],
    success: (
      data: OpenAPI.POST<"/innointel/lists/{list_id}">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/innointel/lists/${listId}`,
      data,
      success,
      fail,
    );
  },
  deleteList(
    listId: string,
    success: (
      data: OpenAPI.DELETE<"/innointel/lists/{list_id}">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "DELETE",
      `/innointel/lists/${listId}`,
      null,
      success,
      fail,
    );
  },
  duplicateList(
    listId: string,
    data: OpenAPI.POST<"/innointel/lists/{list_id}/duplicate">["requestBody"],
    success: (
      data: OpenAPI.POST<"/innointel/lists/{list_id}/duplicate">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/innointel/lists/${listId}/duplicate`,
      data,
      success,
      fail,
    );
  },
  connectExcel(
    listId: string,
    success: (
      data: OpenAPI.POST<"/innointel/lists/{list_id}/connections/microsoftExcel">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/innointel/lists/${listId}/connections/microsoftExcel`,
      null,
      success,
      fail,
    );
  },
  createPowerbiDataset(
    listId: string,
    data: OpenAPI.POST<"/innointel/lists/{list_id}/connections/powerbi">["requestBody"],
    success: (
      data: OpenAPI.POST<"/innointel/lists/{list_id}/connections/powerbi">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/innointel/lists/${listId}/connections/powerbi`,
      data,
      success,
      fail,
    );
  },
  deletePowerbiDataset(
    listId: string,
    datasetId: string,
    success: (
      data: OpenAPI.DELETE<"/innointel/lists/{list_id}/connections/powerbi/{dataset_id}">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "DELETE",
      `/innointel/lists/${listId}/connections/powerbi/${datasetId}`,
      null,
      success,
      fail,
    );
  },
  getListCompanies(
    listId: string,
    params: OpenAPI.GET<"/innointel/lists/{list_id}/companies">["parameters"]["query"],
    success: (
      data: OpenAPI.GET<"/innointel/lists/{list_id}/companies">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    const urlParams = new SearchParams(params);
    api.authenticatedRequest(
      "GET",
      `/innointel/lists/${listId}/companies${urlParams.toSafeString()}`,
      null,
      success,
      fail,
    );
  },
  addListCompanies(
    listId: string,
    data: OpenAPI.POST<"/innointel/lists/{list_id}/companies">["requestBody"],
    success: (
      data: OpenAPI.POST<"/innointel/lists/{list_id}/companies">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/innointel/lists/${listId}/companies`,
      data,
      success,
      fail,
    );
  },
  removeListCompanies(
    listId: string,
    data: OpenAPI.DELETE<"/innointel/lists/{list_id}/companies">["requestBody"],
    success: (
      data: OpenAPI.DELETE<"/innointel/lists/{list_id}/companies">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "DELETE",
      `/innointel/lists/${listId}/companies`,
      data,
      success,
      fail,
    );
  },
  emailCompanies(
    params: OpenAPI.POST<"/innointel/companies/email">["parameters"]["query"],
    data: OpenAPI.POST<"/innointel/companies/email">["requestBody"],
    success: (
      data: OpenAPI.POST<"/innointel/companies/email">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    const urlParams = new SearchParams(params);
    api.authenticatedRequest(
      "POST",
      `/innointel/companies/email?${urlParams.toString()}`,
      data,
      success,
      fail,
    );
  },
  subscribeToList(
    listId: string,
    success: (
      data: OpenAPI.POST<"/innointel/lists/{list_id}/subscribe">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/innointel/lists/${listId}/subscribe`,
      null,
      success,
      fail,
    );
  },
  unsubscribeFromList(
    listId: string,
    success: (
      data: OpenAPI.DELETE<"/innointel/lists/{list_id}/subscribe">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "DELETE",
      `/innointel/lists/${listId}/subscribe`,
      null,
      success,
      fail,
    );
  },
  getListNews(
    listId: string,
    page: number,
    success: (
      data: OpenAPI.GET<"/innointel/lists/{list_id}/news">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/innointel/lists/${listId}/news?page=${page}`,
      null,
      success,
      fail,
    );
  },
  getListLogs(
    listId: string,
    success: (
      data: OpenAPI.GET<"/innointel/lists/{list_id}/logs">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/innointel/lists/${listId}/logs`,
      null,
      success,
      fail,
    );
  },
  getListAnalysis(
    listId: string,
    success: (
      data: OpenAPI.GET<"/innointel/lists/{list_id}/analysis">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/innointel/lists/${listId}/analysis`,
      null,
      success,
      fail,
    );
  },
  getDashboards(
    params: OpenAPI.GET<"/innointel/dashboards">["parameters"]["query"],
    success: (data: OpenAPI.GET<"/innointel/dashboards">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    const queryParams = new SearchParams(params);
    api.authenticatedRequest(
      "GET",
      `/innointel/dashboards${queryParams.toSafeString()}`,
      null,
      success,
      fail,
    );
  },
  createDashboard(
    data: OpenAPI.PUT<"/innointel/dashboards">["requestBody"],
    success: (data: OpenAPI.PUT<"/innointel/dashboards">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "PUT",
      "/innointel/dashboards",
      data,
      success,
      fail,
    );
  },
  getDashboard(
    id: string,
    success: (
      data: OpenAPI.GET<"/innointel/dashboards/{dashboard_id}">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/innointel/dashboards/${id}`,
      null,
      success,
      fail,
    );
  },
  deleteDashboard(
    id: string,
    success: (
      data: OpenAPI.DELETE<"/innointel/dashboards/{dashboard_id}">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "DELETE",
      `/innointel/dashboards/${id}`,
      null,
      success,
      fail,
    );
  },
  subscribeToDashboard(
    id: string,
    toSubscribe: boolean,
    success: (
      data: OpenAPI.POST<"/innointel/dashboards/{dashboard_id}/subscribe">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      toSubscribe ? "POST" : "DELETE",
      `/innointel/dashboards/${id}/subscribe`,
      null,
      success,
      fail,
    );
  },
  updateDashboardEventLocation(
    id: string,
    data: OpenAPI.POST<"/innointel/dashboards/{dashboard_id}/eventLocation">["requestBody"],
    success: (
      data: OpenAPI.POST<"/innointel/dashboards/{dashboard_id}/eventLocation">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/innointel/dashboards/${id}/eventLocation`,
      data,
      success,
      fail,
    );
  },
  getNotes(
    id: string,
    success: (
      data: OpenAPI.GET<"/innointel/companies/{company_id}/notes">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/innointel/companies/${id}/notes`,
      null,
      success,
      fail,
    );
  },
  createNote(
    id: string,
    data: OpenAPI.PUT<"/innointel/companies/{company_id}/notes">["requestBody"],
    success: (
      data: OpenAPI.PUT<"/innointel/companies/{company_id}/notes">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "PUT",
      `/innointel/companies/${id}/notes`,
      data,
      success,
      fail,
    );
  },
  deleteNote(
    id: string,
    noteId: string,
    success: (
      data: OpenAPI.DELETE<"/innointel/companies/{company_id}/notes/{note_id}">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "DELETE",
      `/innointel/companies/${id}/notes/${noteId}`,
      null,
      success,
      fail,
    );
  },
});
